// extracted by mini-css-extract-plugin
module.exports = {"infoItems":"vendor-info_infoItems__1W2uy"};